var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlarm1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 16,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#0096DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 46.3333V53.3333H35.0003V46.3333H51.3337V62.6666C51.3337 63.2854 51.0878 63.8789 50.6502 64.3165C50.2127 64.7541 49.6192 64.9999 49.0003 64.9999H7.00033C6.38149 64.9999 5.78799 64.7541 5.35041 64.3165C4.91282 63.8789 4.66699 63.2854 4.66699 62.6666V46.3333H21.0003ZM25.667 41.6666H30.3337V48.6666H25.667V41.6666ZM16.3337 27.6666V20.6666C16.3337 20.0477 16.5795 19.4543 17.0171 19.0167C17.4547 18.5791 18.0482 18.3333 18.667 18.3333H37.3337C37.9525 18.3333 38.546 18.5791 38.9836 19.0167C39.4212 19.4543 39.667 20.0477 39.667 20.6666V27.6666H49.0003C49.6192 27.6666 50.2127 27.9124 50.6502 28.35C51.0878 28.7876 51.3337 29.3811 51.3337 29.9999V41.6666H35.0003V36.9999H21.0003V41.6666H4.66699V29.9999C4.66699 29.3811 4.91282 28.7876 5.35041 28.35C5.78799 27.9124 6.38149 27.6666 7.00033 27.6666H16.3337ZM21.0003 22.9999V27.6666H35.0003V22.9999H21.0003Z",
    fill: "#0096DD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm1);
export default __webpack_public_path__ + "static/media/Icon_Alarm-1.184da60e26ceb648002f79929b4b1895.svg";
export { ForwardRef as ReactComponent };